export const tableWrapperStyles = {
  gap: '10px',
};

export const tableTitleStyles = {
  padding: '16px',
};

export const tableContainerStyles = {
  position: 'relative',
  border: '1px solid',
  borderColor: ({ palette }) => `${palette.border.default} !important`,
  borderRadius: '8px',
};

export const tableHeadStyles = {
  backgroundColor: ({ palette }) => palette.background.default,

  '& .table-cell': {
    padding: '8px 15px',
    color: ({ palette }) => palette.text.primary,
  },
};

export const tableBodyStyles = {
  overflowY: 'auto',
  scrollBehavior: 'smooth',
  position: 'relative',

  '& .table-cell': {
    padding: '8px 15px',
    color: ({ palette }) => palette.text.secondary,
  },

  '& tr:last-of-type .table-cell': {
    borderBottom: 'none',
  },
};
